<template>
    <section class="bg-gray-800">
        <div class="container mx-auto justify-center pt-4 pb-20 lg:py-20">
            <div
                class="flex flex-col lg:flex-row w-5/6 justify-around mx-auto items-center"
            >
                <div
                    class="mb-8 pb-8 lg:mb-0 lg:w-1/4 text-4xl text-white font-bold center"
                >
                    FABRES ORBIS
                </div>
                <div class="lg:w-1/2">
                    <h1
                        class="text-3xl font-normal mb-0 text-white pb-2 ml-5 pl-4 border-l-2 border-yellow-400"
                    >
                        Origin of Name
                    </h1>
                    <hr class="border-b-2 border-yellow-400" />
                    <p
                        class="text-lg leading-relaxed text-white pt-2 ml-5 pl-4 border-l-2 border-yellow-400"
                    >
                        The name Fabres Orbis is derived from the two Latin
                        words, 'FABRES' meaning Engineers and 'ORBIS' meaning
                        World. Together it means "The World of Engineers".
                        <br />
                        In short we call as "FO".
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>
